import { Button, Input, MagellanPopup } from 'components/atoms';
import TrackSearchCard from 'components/molecules/card/track-search/TrackSearchCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { useGetTracksListInfinite } from 'services/tracks';
import { ITrackResponse } from 'services/tracks/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface ITrackSelectPopupFormProps {
  trigger: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectTrack?: (track: ITrackResponse, actions: PopupActions) => void;
  disabledTracks?: string[];
}

const TrackSelectPopupForm = ({
  trigger,
  onSelectTrack,
  disabledTracks,
}: ITrackSelectPopupFormProps) => {
  const popupRef = useRef<PopupActions | null>(null);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const tracks = useGetTracksListInfinite({ itemCount: 10 }, open);
  const [track, setTrack] = useState<ITrackResponse | null>(null);

  return (
    <Popup
      ref={popupRef}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
        setTrack(null);
        setSearch('');
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t('button.select-track-from-catalog')}</MagellanPopup.Header>
        <Input.Text
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          name=""
          appBackground
          placeholder={t('input.placeholder.search-track')}
        />
        <div className="flex flex-col w-full gap-4 overflow-auto h-[450px] [scrollbar-width:none] ">
          {tracks.data?.pages
            .flat()
            .filter((t) => !disabledTracks?.includes(t.id))
            .map((t) => (
              <TrackSearchCard
                key={t.id}
                track={t}
                isSelected={t.id === track?.id}
                onClick={() => setTrack(t.id === track?.id ? null : t)}
              />
            ))}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            disabled={!track}
            onClick={() =>
              track && onSelectTrack && popupRef.current && onSelectTrack(track, popupRef.current)
            }
          >
            <Button.Text text={t('button.add')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default TrackSelectPopupForm;
